﻿window.HandleEmailSuccess = function (response, element) {
    var isValid = false;

    if (!response.IsBadRequest && !response.IsEmailExists) {
        isValid = true;
    }
    else {
        $(element).data("errMessage", response.ErrDescription);
    }

    //$('.form').find('input[class~="id-number"]').closest('.input-field-wrap').find('.input-field-spinner').hide();
    return isValid;
};


//window.resetCaptchaOTPCounter = function (response) {
//    //alert('resetCaptchaOTPCounter ' + response);
//    getAjaxData("/api/sitecore/LoginRegistration/ResetCaptchaOTPCounter", "POST", false, null, function (data) {
//        if (data) {
//            var a = 0; //Just dummy
//        }
//    });
//};

window.hideReCaptcha = function (response) {
    $('.div-recaptcha-id').attr("style", "display:block;height:0px;width:0px;border:0px;visibility:collapse;margin-bottom:0px;");
};

window.reCaptchaCallback = function (response) {
    var recaptchaResponse = grecaptcha.getResponse();
    if (recaptchaResponse.length != 0) {
        $('.googleRecaptchaClass').val(recaptchaResponse);
        $(".resend-otp").attr('style', 'display:block;');
        //resetCaptchaOTPCounter();

        hideReCaptcha();
        grecaptcha.reset();
    }
};

window.ClearTemporarySession = function (param) {
    sessionStorage.clear();

    var pageName = {
        "pageName": 'OTP'
    };
    getAjaxData("/api/sitecore/Login/ClearTemporarySession", "POST", false, pageName, function (data) {
        if (data) {
            var a = 0;
        }
    });
};

window.GotoOTPRegistration = function (param) {
    $(".loading-screen").show();
    ClearTemporarySession();

    var OTPInputType = {
        "Email": $('.email, .email-pesel').val(),
        "UserToken": $('[data-validator-id="login-home-user-token"]').val(),
        "OtpPageItem": $('[data-validator-id="otp-page-item"]').val(),
        "CanResendOTP": 'yes'
    };
    getAjaxData("/api/sitecore/Login/GetOTPUrl", "POST", false, OTPInputType, function (data) {
        if (data.success) {
            var url = data.OTPUrl;
            $(location).attr('href', url);
        }
    });
};

export default class ForgetPassword {
    constructor() {
        this.dom = {
            $: window.$
        };
        this.init();
    }
    init() {
        this.onLoad();

        this.sendForgotPasswordLink();
        this.loginBackClick();

        this.setCaptchaValueOnSubmitClick();
        this.validateCaptcha();
        //this.resendRegistrationOTP();
    }

    onLoad() {

        hideReCaptcha();
        //resetCaptchaOTPCounter();
    }

    sendForgotPasswordLink() {
        $('.login-home-submit').click(function (e) {

            if ($('.email, .email-pesel').val().length > 0) {
                $(".loading-screen").show();
                event.preventDefault();
                var isValidationError = ($('.email, .email-pesel').closest('.form-row').find('span.form-error').html().length > 0);
                if (isValidationError) {
                    $('.email, .email-pesel').focus();
                    $(".loading-screen").hide();
                    $('.form').find('.form-error-global').removeClass('hidden');
                }
                else if ($(".form").valid()) {
                    //set email in local storage
                    localStorage.setItem('emailcheck', $('.email, .email-pesel').val());
                    var credentialsInputType = {
                        "LoginEmailAddress": $('.email, .email-pesel').val(),
                        "PWD": '',
                        "CheckCredentialsType": 'CHECK_EMAIL',
                        "ForgotPWDPage":true
                    };
                    getAjaxData("/api/sitecore/Login/CheckUserCredentials", "POST", true, credentialsInputType, function (data) {
                        if (data) {
                            $('[data-validator-id="login-home-user-token"]').val('');
                            if (!data.success && data.ErrorCode.trim().length > 0)// 'EMAIL_NOT_FOUND' || data.ErrorCode == 'ACCOUNT_LOCKED' || data.ErrorCode == 'WRONG_PWD') {
                            {
                                GotoOTPRegistration();
                            }
                            else {
                                $('[data-validator-id="login-home-user-token"]').val(data.UserToken);                                
                                GotoOTPRegistration();
                            }
                        }
                    });
                }
            }
        });
    }

    loginBackClick() {
        $('.login-back').click(function (e) {
            event.preventDefault();
            $('.form').find('.form-error-global').addClass('hidden');
            $('.login-div').attr("style", "display:none");
            $('.login-home-div').attr("style", "display:block");
        });
    }


    resendRegistrationOTP() {
        $('.resend-otp').click(function (e) {
            var input = '';
            getAjaxData("/api/sitecore/ForgotPassword/SendPasswordResetLink", "POST", false, input, function (data) {
                if (data) {
                    //ReCaptcha show/hide
                    data = JSON.parse(data);
                    if (data.IsSuccess) {
                    }
                    else {

                        if (data.ReCaptchaCounter > 2) {
                            $('.div-recaptcha-id').attr("style", "display:block");
                            $('.googleRecaptchaClass').val('');
                            resetCaptchaOTPCounter();
                        }
                        else {
                            if ($('.googleRecaptchaClass').val().trim() != '') {
                                hideReCaptcha();
                                grecaptcha.reset();
                            }
                        }
                    }

                }
            });
        });
    }

    validateCaptcha() {
        var that = this;
        var keys = { "keys": ["CAPTCHA_REQUIRED"] };
        getAjaxData("/api/sitecore/validations/GetValidationMessages", "POST", false, keys, function (data) {
            if (data) {
                $.validator.addMethod('validateCheckCaptcha', function (value, element) {
                    return that.verifyCaptcha();
                }, data["CAPTCHA_REQUIRED"]);

                $.validator.addClassRules('googleRecaptchaClass', { validateCheckCaptcha: true });
            }
        });
    }

    verifyCaptcha() {
        if ($('.div-recaptcha-id').css('visibility') == 'collapse') {
            return true;
        }
        var response = $('.googleRecaptchaClass').val().trim();
        var isValid = false;
        //resetCaptchaOTPCounter();
        return isValid;
    }

    setCaptchaValueOnSubmitClick() {
        $('.recaptcha').click(function (e) {
            var recaptchaResponse = grecaptcha.getResponse();
            //cLog(recaptchaResponse);
            //cLog(recaptchaResponse.length);
            if (recaptchaResponse.length != 0) {
                $('.googleRecaptchaClass').val(recaptchaResponse);
                //resetCaptchaOTPCounter();
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => new ForgetPassword());
